<script setup lang="ts">
import ExerciseMCQ from "~/features/computer/components/ExerciseMCQ.vue";
import { functionMistakes, functionsQuizQuestions } from "~/features/python/ch2/functions/data/functions.content";
</script>

<template>
  <section class="space-y-4 rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Aam ghaltiyan</h2>
      <p class="text-sm text-slate-600">Yeh wo jagah hai jahan bachay aksar confuse ho jate hain.</p>
    </div>

    <article
      v-for="mistake in functionMistakes"
      :key="mistake.id"
      class="rounded-2xl bg-rose-50 p-4 ring-1 ring-rose-100"
    >
      <h3 class="text-sm font-semibold text-slate-900">{{ mistake.title }}</h3>
      <pre class="mt-3 overflow-x-auto rounded-xl bg-slate-950 p-3 text-xs leading-6 text-slate-100"><code>{{ mistake.wrong }}</code></pre>
      <p class="mt-3 text-xs font-semibold uppercase tracking-wide text-emerald-700">Sahi tareeqa</p>
      <pre class="mt-2 overflow-x-auto rounded-xl bg-white p-3 text-xs leading-6 text-slate-800 ring-1 ring-emerald-100"><code>{{ mistake.right }}</code></pre>
      <p class="mt-3 text-sm text-slate-700">{{ mistake.explanation }}</p>
    </article>

    <div class="space-y-4 pt-2">
      <div>
        <h2 class="text-lg font-semibold text-slate-900">Chhota test</h2>
        <p class="mt-1 text-sm text-slate-600">Ab check karo ke function ka idea samajh aaya ya nahi.</p>
      </div>

      <ExerciseMCQ
        v-for="question in functionsQuizQuestions"
        :key="question.id"
        :question="question"
      />
    </div>
  </section>
</template>
